// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "" + {"375":"eager-p0-core-components","551":"eager-p1-core-slices"}[chunkId] + "." + {"375":"bfa1be3630fa97a25f32","551":"656c34844437618ef49b"}[chunkId] + ".css";
};